import type {AxiosError, AxiosInstance, AxiosResponse} from 'axios'
import {APP_ROUTES} from './authInterceptor'
import {HTTP_STATUS_CODES} from '@/utils/constants/globalConstants'

const onUnauthorizedError = async () => {
  localStorage.removeItem('accessToken')
  window.location.href = APP_ROUTES.LOGIN
}

const createErrorMessage = (error: AxiosError): string => {
  const status = error.response?.status
  const serverMessage = (error.response?.data as any)?.message

  if (status === HTTP_STATUS_CODES.UNAUTHORIZED) return 'Your session has expired.'
  if (status === HTTP_STATUS_CODES.FORBIDDEN) return 'Access denied.'
  if (status === HTTP_STATUS_CODES.NOT_FOUND) return 'Resource not found.'
  if (status && status >= HTTP_STATUS_CODES.INTERNAL_SERVER_ERROR) return serverMessage || 'Server error.'
  if (error.code === 'ERR_NETWORK') return 'Network error.'

  return error.message || 'Unexpected error.'
}

export const handleError = async (error: AxiosError): Promise<never> => {
  const message = createErrorMessage(error)
  ;(error as any).userMessage = message

  if (error.response?.status === HTTP_STATUS_CODES.UNAUTHORIZED) {
    await onUnauthorizedError()
  }

  return Promise.reject(error)
}

export const attachErrorInterceptor = (axios: AxiosInstance): AxiosInstance => {
  axios.interceptors.response.use(
    (response: AxiosResponse) => response,
    (error: AxiosError) => handleError(error),
  )
  return axios
}
